import type { DataResponse, User, UserProfile, UserSearchResult } from "@/types";
import { api } from "../api";

/** Convert a camelCase key to snake_case. */
function toSnakeCase(key: string): string {
  return key.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`);
}

export const authService = {
  getProfile: () => api.get<DataResponse<UserProfile>>("/auth/me"),
  updateSettings: (settings: Partial<UserProfile["preferences"]>) => {
    // Generically convert camelCase keys to snake_case for the backend.
    // Only includes keys that are explicitly present (not undefined).
    const payload: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(settings)) {
      if (value !== undefined) {
        payload[toSnakeCase(key)] = value;
      }
    }
    return api.put<DataResponse<User>>("/auth/me/settings", payload);
  },
  searchUsers: (query: string) =>
    api.get<DataResponse<UserSearchResult[]>>(`/auth/users/search?q=${encodeURIComponent(query)}`),
};
